import { DashboardCell } from 'generated/graphql';

export function handleDropInTheSameRow({
  dropTargetIdx,
  draggedCell,
  destinationRowCells,
}: {
  dropTargetIdx: number;
  draggedCell: DashboardCell;
  destinationRowCells: DashboardCell[];
}) {
  destinationRowCells.splice(dropTargetIdx, 0, draggedCell);

  const draggedCellIdx = destinationRowCells.findIndex(
    (item, idx) => draggedCell.id === item.id && idx !== dropTargetIdx,
  );
  destinationRowCells.splice(draggedCellIdx, 1);
}
